import { GQLStickerFragment } from '@theprintbar/graphql';
import { cn } from '@theprintbar/shared';
import { Pill } from '@theprintbar/ui';

export interface CTAContainerProps {
	pill?: {
		text: string;
		colour: string;
	};
	isFull?: boolean;
	sticker?: GQLStickerFragment | null;
	stickerPosition?: 'bottom-middle' | 'bottom-right';
	children?: React.ReactNode;
	className?: string;
	pillClassName?: string;
}

export function CTAContainer({ children, pill, sticker, isFull, stickerPosition, className, pillClassName }: CTAContainerProps) {
	let stickerClassName = '';
	switch (stickerPosition) {
		case 'bottom-middle':
			// only for desktop (with non-split cta on desktop)
			stickerClassName = 'hidden lg:block left-1/3 translate-y-1/2 bottom-0 w-[280px] ';
			if (isFull) stickerClassName = 'hidden lg:block left-1/3 bottom-0 w-[280px] ';
			break;
		case 'bottom-right':
			// for desktop & mobile (journal carousel...)
			stickerClassName = 'right-16 lg:right-24 translate-y-1/2 bottom-0 w-20 lg:w-36';
			break;
	}

	return (
		<div className={cn('relative h-full w-full', className)}>
			{/* Pill for desktop & mobile */}
			{pill && (
				<Pill
					className={cn(
						'flex w-fit h-6 text-xs absolute z-10 right-10 lg:right-12 -translate-y-1/2',
						pill.colour === '#2B42FA' ? 'text-white' : 'text-blue',
						pillClassName,
					)}
					style={{ backgroundColor: pill.colour }}
				>
					{pill.text}
				</Pill>
			)}

			{/* Sticker */}
			{sticker && (
				<img
					loading="lazy"
					alt={sticker.altText || 'sticker'}
					src={`${sticker.image.url}?size=250`}
					className={cn('hidden md:block absolute z-10 aspect-square', stickerClassName)}
				/>
			)}

			{children}
		</div>
	);
}
